const STATUSES = {
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
  INFO: 'info',
  SECONDARY: 'secondary',
};
export { STATUSES as default };
